import { render, staticRenderFns } from "./DashboardMortgages.vue?vue&type=template&id=695ce69c&scoped=true&"
import script from "./DashboardMortgages.vue?vue&type=script&lang=ts&"
export * from "./DashboardMortgages.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardMortgages.vue?vue&type=style&index=0&id=695ce69c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695ce69c",
  null
  
)

export default component.exports